import { render, staticRenderFns } from "./BundlePage.vue?vue&type=template&id=3d5f2c67"
import script from "./BundlePage.vue?vue&type=script&lang=js"
export * from "./BundlePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports